<!--
 * @Author: rossdong@yntengyun.com
 * @Date: 2024-10-15 11:29:13
 * @Description: 游客投诉增长率
-->
<template>
  <div class="container">
    <!-- header -->
    <div class="head">
      <div class="title">
        <div class="text">{{ assessName }}</div>
        <div class="flex-row f-s-s mt-8">
          <span> {{ areaName }}</span>
          <span class="ml-8">{{ quarterName }}</span>
        </div>
      </div>
      <div class="rules">
        <div v-if="Number(deduction) == 0" class="no-de">未扣分</div>
        <div v-else class="branch">-{{ deduction }}</div>
        <div class="num">{{ score }}/{{ totalScore }}</div>
      </div>
    </div>
    <!-- 考评信息  -->
    <div class="mx-12">
      <div class=" mt-24 mb-12 text-[#333333] text-16  font-bold">
        考评信息
      </div>
      <div class="card-bg ">
        <div class="flex-col px-12 py-12 text-grey-a">
          <div class="" v-if="deduction">
            扣分原因：{{ result?.complainRank | deductionReason(result) }}
          </div>
          <div class="" v-else>暂无扣分</div>
        </div>
      </div>

    </div>

    <!-- 投诉情况  -->
    <div class="mx-12">
      <div class=" mt-24 mb-12 text-[#333333] text-16  font-bold">
        投诉情况
      </div>
      <div class="card-bg ">
        <div class="flex-col">
          <!-- 同比增长率 -->
          <div v-if="result?.complainRank <=10 " class="flex flex-col justify-center items-center py-24 border-0 border-solid border-b-[1px]  border-b-[#EEEEEE]">
            <div>同比增长率</div>
            <div class="my-8">
              <span class="text-[#36B374] text-32 font-bold">{{ result?.upRateRank }}</span>
              <span class="text-[#36B374] text-10 font-400 align-text-bottom">名</span>
            </div>
            <div class="text-[#999999]">同比增长率 {{ result?.complainUpRate }}</div>

          </div>
          <div class="flex flex-row ">
            <!-- left -->
            <div class="flex-1 flex flex-col items-center justify-center border-0 border-solid border-r-[1px]  border-r-[#EEEEEE] py-24">
              <div class="text-12 text-[#333333]  line-clamp-1">{{ quarterName }}涉旅投诉排名</div>
              <div class="mt-8">
                <span class="text-[#36B374] text-32 font-bold">{{ result?.complainRank }}</span>
                <span class="text-[#36B374] text-10 font-400 align-text-bottom">名</span>
              </div>
              <!-- 后6 名 -->
              <div v-if="result?.complainRank > 10 " class="mt-8">
                <span class="text-[#333333] text-12 ">涉旅投诉数量：{{ result?.complainNum || "-" }}件</span>
              </div>
            </div>
            <!-- right -->
            <div v-if="result?.complainRank <=10 " class="flex-1 flex flex-col items-center justify-center py-12">
              <!-- 今年 -->
              <div class="w-full border-0 border-b-[1px] border-solid border-b-[#EEEEEE] flex flex-col items-center">
                <div class="text-12 text-[#333333] ">{{ quarterName }}投诉数量</div>
                <div class="mt-8  text-center mb-16">
                  <span class="text-[#36B374] text-32 font-bold">{{ result?.complainNum }}</span>
                  <span class="text-[#36B374] text-10 font-400 align-text-bottom">件</span>
                </div>
              </div>
              <!-- 去年 -->
              <div class="text-12 text-[#333333] line-clamp-1 mt-16 flex flex-col items-center">去年该季度投诉量</div>
              <div class="mt-8 ">
                <span class="text-[#36B374] text-32 font-bold">{{ result?.beforeComplainNum }}</span>
                <span class="text-[#36B374] text-10 font-400 align-text-bottom">件</span>
              </div>
            </div>

          </div>

        </div>
      </div>

    </div>

    <!-- 没有扣分记录提示 -->
    <div class="noData-bg" v-if="!result">
      <nodata :noData="noData"></nodata>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import nodata from "../components/nodata"; // 没有数据
import deducList from "./components/deducList"; // 扣分列表

import API from "../../../service/index";
import commonAPI from "../../../utils/common";
import { type } from "@/utils/configJson";

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    nodata,
    deducList,
  },
  name: 'touristComplainIncresRate',
  props: {

  },
  data() {
    // 这里存放数据
    return {
      assessName: this.$route.query.assessName,
      noData: {
        title: "暂无数据",
      },
      asscessType: this.$route.query.asscessType,
      deduction: this.$route.query.deduction,
      score: this.$route.query.score,
      totalScore: this.$route.query.totalScore,

      quarterName: this.$route.query.quarterName,
      year: this.$route.query.year,
      quarter: this.$route.query.quarter,
      area: this.$route.query.area,
      areaName: this.$route.query.areaName,
      result: null,
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  filters: {
    deductionReason(rank, result) {
      if (rank == 0) return ''
      if (rank <=10 && result) {
        return "本季度涉旅投诉量排名第" + result?.complainRank + "名,同比增长率" + result?.complainUpRate + "涉旅投诉增长率第" + result?.upRateRank + "名，扣" + result?.deduction;
      }
      return "本季度涉旅投诉量排名第" + result?.complainRank + "名，扣" + result?.deduction ;
    }
  },
  // 方法集合
  methods: {
    getdeductionList(year, quarter, area) {
      API.findAllComplainUpRate({ year, quarter, area }).then((res) => {
        console.log("-----列表:", res);
        if (res.ret == 0 && res.data && res.data.all && res.data.all.length > 0) {
          this.result = res.data.all.find(item => item.area == this.area)
        }

      });
    },


  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    console.log('output->[ created ] >', this.$route.query)
    this.getdeductionList(this.year, this.quarter, this.area)
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, // 生命周期 - 创建之前
  beforeMount() { }, // 生命周期 - 挂载之前
  beforeUpdate() { }, // 生命周期 - 更新之前
  updated() { }, // 生命周期 - 更新之后
  beforeDestroy() { }, // 生命周期 - 销毁之前
  destroyed() { }, // 生命周期 - 销毁完成
  activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//  @import url(); 引入公共css类
.card-bg {
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
  border-radius: 3px;
  
}


.container {
  min-height: 100vh;
  background: #fbfbfb;
  display: flex;
  flex-direction: column;
  position: relative;

  .noData-bg {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
  }

  .head {
    background: #fff;
    padding: 20px 12px;
    display: flex;
    justify-content: space-between;

    .title {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-right: 50px;

      .text {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 28px;
      }

      .tit {
        position: relative;
        display: flex;
        color: #999;
        font-size: 12px;
        margin-top: 12px;

        span {
          position: relative;
          padding-right: 16px;
        }

        span::after {
          content: "";
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 12px;
          height: 12px;
          background: url(../../../assets/image/t-right.png) no-repeat;
          background-size: 12px 12px;
        }
      }
    }

    .rules {
      display: flex;
      flex-direction: column;
      color: #666666;
      text-align: right;

      .num {
        color: #999999;
        font-size: 14px;
        margin-top: 8px;
      }

      .branch {
        height: 22px;
        font-size: 22px;
        // font-family: DIN-Medium, DIN;
        font-weight: 500;
        color: rgba(255, 77, 77, 1);
        line-height: 28px;
      }

      .no-de {
        min-width: 60px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(54, 179, 116, 1);
        line-height: 22px;
      }
    }
  }
}

</style>